import { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import styles from './Modal.module.css';
import IconClose from "@/components/icons/IconClose";
import Divider, { DividerProps } from '../Divider/Divider';

export interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  closeOnOutsideClick?: boolean;
  closeIcon?: boolean;
  children?: ReactNode;
  className?: string;
  inlineWidth?: string;
  onClose?: () => void;
};

export const Modal = ({
  open,
  onOpenChange,
  closeOnOutsideClick = true,
  closeIcon = true,
  className,
  inlineWidth,
  onClose,
  children,
}: ModalProps) => {

  const handleModalClose = (open: boolean) => {
    onOpenChange?.(open);
    onClose?.();
  };

  return (
    <Dialog.Root open={open} onOpenChange={handleModalClose}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content
          className={`${styles.modalContent} ${!!className ? className : ""}`}
          style={{width: inlineWidth}}
          onInteractOutside={(e) => {
            if (!closeOnOutsideClick) e.preventDefault();
          }}
          aria-describedby={undefined} // @TODO
        >
          {/* required for accessibility: @TODO allow parameterizing the title: */}
          <div style={{display:"none"}}><Dialog.Title></Dialog.Title></div>

          {closeIcon && (
            <Dialog.DialogClose className={styles.closeButton}>
              <IconClose size="1.5rem" />
            </Dialog.DialogClose>
          )}
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export interface ModalSectionProps {
  children?: ReactNode;
  divider?: boolean;
  className?: string;
  dividerProps?: DividerProps;
  marginRight?: string;
};

export const ModalHeader = ({
  divider = true,
  className,
  dividerProps,
  children,
  marginRight = "2.5rem",
}: ModalSectionProps) => {
  return (
    <>
      <div className={`${styles.modalHeader} ${!!className ? className : ""}`} style={{marginRight}}>
        {children}
      </div>
      {divider && <Divider margin={"0"} {...dividerProps} />}
    </>
  )
};

export interface ModalBodyProps {
  children?: ReactNode;
  className?: string;
  divider?: boolean;
  dividerProps?: DividerProps;
};

export const ModalBody = ({
  className,
  divider = false,
  dividerProps,
  children,
}: ModalBodyProps) => {
  return (
    <>
      <div className={`${styles.modalBody} ${!!className ? className : ""}`}>
        {children}
      </div>
      {divider && <Divider margin={"0"} {...dividerProps} />}
    </>
  );
};

export const ModalFooter = ({
  children,
  divider = true,
  className,
  dividerProps,
}: ModalSectionProps) => {
  return (
    <>
      {divider && <Divider margin={"0"} {...dividerProps} />}
      <div className={`${styles.modalFooter} ${!!className ? className : ""}`}>
        {children}
      </div>
    </>
  );
};